module.exports = __webpack_public_path__ + "img/snowflake.e88176b6.svg";